'use client'
import useUser from 'auth/hooks/useUser'
import { CustomerType } from 'ecosystem'
import { useVatPreference } from 'ui/hooks/useVatPreference'

/**
 * Resolve whether prices should render ex-VAT.
 *
 * BUSINESS customers always see ex-VAT regardless of the toggle.
 * For all other callers, the user's localStorage-backed pref wins
 * (default: VAT-included).
 */
export const useVatMode = (): { excludeVat: boolean } => {
  const { user } = useUser()
  const { excludeVat } = useVatPreference()

  const isB2B = user?.customer?.type === CustomerType.BUSINESS

  return { excludeVat: isB2B ? true : excludeVat }
}
